import { IS_NATIVE_APP_CLIENT, poll } from './helpers';
import { Customer } from './environment';
import { getPageType } from './gtm-data-layer';

export const identifyUserInFullStory = () => {
  try {
    const userId = Customer?.id?.toString();
    const userEmail = Customer?.email;

    if (userId) {
      executeFS('setIdentity', {
        uid: userId,
        properties: {
          displayName: userEmail,
          email: userEmail,
        },
      });
    } else {
      executeFS('setIdentity', { anonymous: true });
    }
  } catch (error) {
    console.error('Error capturing user on page load:', error);
  }
};

export const fireFSMenuLinkTracking = (link: HTMLAnchorElement) => {
  try {
    const { dataset, innerText, href } = link;

    const properties = {
      link_id: dataset.nav,
      link_text: innerText,
      link_url: href,
    };

    executeFS('trackEvent', {
      name: 'fs_menu_link',
      properties,
    });
  } catch (err) {
    console.error(err);
  }
};

export const pushPageViewEventToFS = (additionalProps: object = {}) => {
  try {
    if (IS_NATIVE_APP_CLIENT) return;

    const { host, pathname } = window.location;

    executeFS('setProperties', {
      type: 'page',
      properties: {
        pageName: `${host}${pathname}`,
        page_type: getPageType(pathname),
        user_id: Customer?.id?.toString() || '',
        ...additionalProps,
      },
    });
  } catch (err) {
    console.error('Error caputring FS page properties', err);
  }
};

export const executeFS = (method: string, options: object = {}) => {
  poll(() => typeof window.FS === 'function', 5000, 1000)
    .then(() => window?.FS?.(method, options))
    .catch((error) => {
      console.log(error);
    });
};
